import { ResolveMultiSelectOption } from '../types';

export function getSearchStringFromOption<T>(
  option: ResolveMultiSelectOption<T>,
): string {
  if (typeof option.label === 'string') return option.label;
  return '';
}

export function checkIsSelected<T>(msValue: Array<T>, optValue: T) {
  return msValue.some((el) => el === optValue);
}

export default {
  getSearchStringFromOption,
  checkIsSelected,
};
